// extracted by mini-css-extract-plugin
export default {"wrapper":"BankSslBanner_wrapper__0kPEJ"};